export default "__VITE_ASSET__93689531__"